<template>
  <v-container fluid>
    <div class="flex-col-start-start gap-4">
      <div class="flex-row-between-center w-100">
        <HistoryFilter
          :filterData="filter"
          :loading="filterLoading"
          @filter="handleFilter"
        />
        <HistoryExport
          title="Recommendation"
          :filterData="filter"
          :exportData="exportData"
          :disabled="recommendationHistory.length === 0"
        />
      </div>
      <Loader v-if="loading" />
      <NoRecord v-else-if="recommendationHistory.length === 0" />
      <div class="flex-col-start-start gap-2 w-100" v-else>
        <RecommendationHistoryCard
          v-for="recommendationData in recommendationHistory"
          :key="recommendationData.id"
          :recommendationData="recommendationData"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import HistoryFilter from "@/components/lists/HistoryFilter.vue";
import HistoryExport from "@/components/lists/HistoryExport.vue";
import NoRecord from "@/components/lists/NoRecord.vue";
import Loader from "@/components/lists/Loader.vue";
import RecommendationHistoryCard from "./fragments/history.card.vue";
import { GET_RECOMMENDATION_HISTORY } from "@/core/services/store/modules/hmi/hmi.module";
import moment from "jalali-moment";
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";

export default {
  name: "RecommendationHistory",

  data() {
    return {
      loading: false,
      filterLoading: false,
      filter: {
        created_at_from: undefined,
        created_at_to: undefined,
        limit: undefined,
      },
    };
  },

  computed: {
    ...mapGetters(["recommendationHistory"]),
    exportData() {
      const headers = [
        "time",
        "target",
        "target value",
        "interval",
        "carbon",
        "metallization",
        "production rate",
      ];
      let data = this.recommendationHistory.map((recommendation) => {
        return {
          time: moment(new Date(recommendation.time)).format(
            "jYYYY/jMM/jDD hh:mm"
          ),
          target: recommendation.targetParam,
          "target value": recommendation.targetValue,
          interval: recommendation.interval,
          carbon: recommendation.carbon,
          metallization: recommendation.metallization,
          "production rate": recommendation.productionRate,
          ...recommendation.inputParameters,
        };
      });

      this.recommendationHistory.forEach((recommendation, index) => {
        recommendation.parameters.forEach((parameter) => {
          const { name, value } = parameter;
          if (!headers.includes(name)) headers.push(name);
          data[index] = { ...data[index], [name]: value };
        });
        Object.keys(recommendation.inputParameters).forEach((key) => {
          if (!headers.includes(key)) headers.push(key);
        });
      });

      return { headers, data };
    },
  },

  async created() {
    await this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.filterLoading = true;
      await this.$store
        .dispatch(GET_RECOMMENDATION_HISTORY, this.filter)
        .then()
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        })
        .finally(() => {
          this.loading = false;
          this.filterLoading = false;
        });
    },
    handleFilter({ key, value }) {
      this.filter = { ...this.filter, [key]: value };
    },
  },

  watch: {
    filter: async function (value) {
      this.filterLoading = true;
      await this.$store
        .dispatch(GET_RECOMMENDATION_HISTORY, value)
        .then()
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        })
        .finally(() => {
          this.filterLoading = false;
        });
    },
  },

  components: {
    HistoryFilter,
    HistoryExport,
    NoRecord,
    Loader,
    RecommendationHistoryCard,
  },
};
</script>
